import apiCall from "./apiCall";

const getInvoiceCompany = async (id: string) => {
    const URL = `/InvoiceCompany/GetDataInvoiceCompany?shipOperatorId=${id}`;
    return apiCall('get', URL);
};

const getInvoiceCompanyById = async (id: string) => {
    const URL = `/InvoiceCompany/GetInvoiceCompanyById/${id}`;
    return apiCall('get', URL);
};

export {
    getInvoiceCompany,
    getInvoiceCompanyById
}